import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Body from './Components/BodyComp/body';
import Footer from './Components/MainComp/footer';
import  NavComp  from './Components/MainComp/nav';
import ContactUs from './Components/ContactComp/contactus';
import AboutUs from './Components/AboutComp/aboutus';
import Admission from './Components/AdmissionComp/admission';
import Department from './Components/AcademicComp/department';
import Programs from './Components/AcademicComp/programs';
import Research from './Components/AcademicComp/research';
import Leadership from './Components/AboutComp/leadership'; 
import History from './Components/AboutComp/history';
import Activities from './Components/CampusLifeComp/activities';
import Sports from './Components/CampusLifeComp/sports';
import Apply from './Components/ApplyComp/apply';
import Visit from './Components/VisitComp/visit';
import News from './Components/NewsComp/news';

import AudiologyCourse from './Components/CourseDetailsComp/audiology-course';
import ItCourse from './Components/CourseDetailsComp/it-course';
import PharmacologyCourse from './Components/CourseDetailsComp/pharmacology-course';
import EnglishCourse from './Components/CourseDetailsComp/english-course';

import SignIn from './Components/LoginComp/signin';
import SignUp from './Components/LoginComp/signup';
import PrivateRoute from './Utils/PrivateRoute'; // Import the PrivateRoute component
import AdminPanel from './Components/AdminComp/adminpanel';
import ForgotPassword from './Components/LoginComp/ForgotPassword';
import UserProfile from './Components/UserComp/userprofile';

function App() {

  return (
    <Router>
      <NavComp />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/department" element={<Department />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/research" element={<Research />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/history" element={<History />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/sports" element={<Sports />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/visit" element={<Visit />} />
        <Route path="/news" element={<News />} />
        <Route path="/audiology-course" element={<AudiologyCourse />} />
        <Route path="/it-course" element={<ItCourse />} />
        <Route path="/pharmacology-course" element={<PharmacologyCourse />} />
        <Route path="/english-course" element={<EnglishCourse />} />



        <Route path="/signin" element={<SignIn />} /> 
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
     


 <Route
          path="/userprofile"
          element={
            <PrivateRoute>
                <UserProfile />
            </PrivateRoute>
          }
        />

                    
                     
        
                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />


      </Routes>

      <Footer />
    </Router>
  );
}

export default App;



